module.exports = __webpack_public_path__ + "static/media/09-ernestnemirovskiy-hovercolor.20e89896.jpg";